export default __webpack_public_path__ + "static/AgeFriendlyCommunities-ad60cab88e3404ed783195a76f628cb7.png";